module.exports = __webpack_public_path__ + "static/AkkuratPro-Regular-d58d6e6b08bfa093be826877cdcb9793.woff2";